import { createStyles } from 'antd-style';

import { header } from '../styles/mixins';

export const useMainMenuHeaderStyles = createStyles(({ token }) => ({
  mainMenuHeader: {
    ...header({
      token,
      breakLg: token.screenLGMin,
      breakSm: token.screenMDMin,
    }),
    border: `1px solid ${token.colorWhite}`,

    '.IconButton': {
      display: 'inline',
    },

    '.ant-form-item': {
      marginBottom: 0,
    },

    '.DropdownMenu-Label': {
      display: 'block',
    },
  },
}));
